import { createSelector } from "@reduxjs/toolkit";
export const presetStateSelector = createSelector([(state) => state], state => state.present);
export const pastStateSelector = createSelector([(state) => state], state => state.past);
export const getPrimaryVersionId = createSelector([(state) => state], (state) => state.primaryVersion);
export const getSecondaryVersionId = createSelector([(state) => state], (state) => state.secondaryVersion);
export const getAllVersions = createSelector([
    presetStateSelector,
    pastStateSelector,
], (current, past) => [current, ...past]);
export const getPrimaryVersion = createSelector([
    getAllVersions,
    getPrimaryVersionId,
], (versions, index) => {
    if (index === null)
        return;
    return versions[index];
});
export const getSecondaryVersion = createSelector([
    getAllVersions,
    getSecondaryVersionId,
], (versions, secondary) => {
    if (secondary === null)
        return;
    return versions[secondary];
});
